import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import image from "../../../../images/plan-selection/testimonials.png"

const Testimonials = ({
  title,
  description,
  imageBefore,
  imageAfter,
  labelBefore = "Vorher",
  labelAfter = "Nachher",
  name,
  reviews = "Eine von 5.000+ tollen Patient:innen-Bewertungen",
  className = "",
}) => (
  <div
    sx={{
      mt: 5,
      py: 5,
      px: 4,
      textAlign: "center",
      border: "1px",
      borderColor: "grey",
      borderRadius: "8px",
      fontSize: 1,
    }}
    className={className}
  >
    <Heading as="h3" size="sm" sx={{ mb: 1 }}>
      {title}
    </Heading>
    {description}
    <div>
      <div
        sx={{
          mt: 4,
          borderRadius: "8px",
          display: "flex",
          gap: "10px",
          flexWrap: "nowrap",
        }}
      >
        {imageBefore && imageAfter ? (
          <>
            <img
              src={imageBefore}
              alt=""
              sx={{
                objectFit: "contain",
                maxWidth: "50%",
                borderRadius: "8px 0 0 8px",
              }}
            />
            <img
              src={imageAfter}
              alt=""
              sx={{
                objectFit: "contain",
                maxWidth: "50%",
                borderRadius: "0 8px 8px 0",
              }}
            />
          </>
        ) : (
          <img
            src={image}
            alt=""
            sx={{
              width: "100%",
              borderRadius: "8px",
            }}
          />
        )}
      </div>
      <div
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          "& > *": { flex: 1 },
        }}
      >
        <div sx={{ textAlign: "center" }}>{labelBefore}</div>
        <div sx={{ textAlign: "center" }}>{labelAfter}</div>
      </div>
    </div>
    <div>
      <div sx={{ mt: 4 }}>{name}</div>
      <div sx={{ mt: 1, color: "textDark" }}>{reviews}</div>
    </div>
  </div>
)

export default Testimonials
